import { Module } from "vuex";
import { RootState } from "@/store/RootState";
import { VodPageState, VoDType } from "@/components/VoD/types";
import { actions } from "@/components/VoD/store/actions";
import { mutations } from "@/components/VoD/store/mutations";
import { getters } from "@/components/VoD/store/getters";

export const state: VodPageState = {
  viewedVodType: VoDType.Movies,
  moviesByGenre: [],
  tvShowsByGenre: [],
  infoModalVodId: 0,
  showVodInfoModal: false,
  refocusCardId: "",
  closePlayer: false,
  cardControls: false,
  playedEpisodePos: undefined,
  showEpisodeInfoModal: false,
  activeEpisode: null,
  promoVoD: null
};

export const vod: Module<VodPageState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
